<template>
    <v-container fluid>
        <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="purple--text"></v-progress-circular>

        <h1>Login callback ...</h1>
    </v-container>

</template>

<script>
    export default {
        name: 'callback',
        data() {
            return {
                title: 'Login callback',
            };
        },
        created() {
            this.$store.dispatch('auth/LOGIN').then(
                () => {
                    this.$router.replace('/');
                },
                () => {
                    this.$router.replace('/error');
                },
            );
        },
    };
</script>



// WEBPACK FOOTER //
// Callback.vue?75c1210c